export default __webpack_public_path__ + "static/media/identity-verification.da139c8b.svg";